@use '@lib/assets/styles/main.scss' as *;

.root {
  width: 100%;
  max-width: $md1;
  margin: 0 auto;
}
